import React from 'react';
import { Badge } from '@mui/material';
import { 
  ORDER_STATUS_CANCELLED, 
  ORDER_STATUS_COMPLETE, 
  ORDER_STATUS_DRAFT, 
  ORDER_STATUS_ORDERED, 
  ORDER_STATUS_PARTIALLYCOMPLETE, 
  ORDER_STATUS_PROCESSING, 
  ORDER_STATUS_REJECTED, 
  ORDER_STATUS_UNABLETOCOMPLETE 
} from '../common/constants';

interface OrderStatusBadgeProps {
  orderStatus: number;
  rounded?: boolean;
  defaultColor?: boolean;
}

const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ orderStatus, rounded = true, defaultColor = false }) => {
  const getClassName = (baseClass: string) => 
    `badge ${defaultColor ? 'defaultColor' : baseClass} ${rounded ? 'rounded' : ''}`;

  return (
    <>
      {orderStatus === ORDER_STATUS_DRAFT && (
        <Badge><span className={getClassName('draft')}>Draft</span></Badge>
      )}
      {orderStatus === ORDER_STATUS_COMPLETE && (
        <Badge><span className={getClassName('complete')}>Complete</span></Badge>
      )}
      {orderStatus === ORDER_STATUS_ORDERED && (
        <Badge><span className={getClassName('ordered')}>Ordered</span></Badge>
      )}
      {orderStatus === ORDER_STATUS_PROCESSING && (
       <Badge><span className={getClassName('processing')}>Processing</span></Badge>
      )}
      {orderStatus === ORDER_STATUS_REJECTED && (
        <Badge><span className={getClassName('rejected')}>Rejected</span></Badge>
      )}
      {orderStatus === ORDER_STATUS_UNABLETOCOMPLETE && (
        <Badge><span className={getClassName('unable-to-complete')}>Unable to Complete</span></Badge>
      )}
      {orderStatus === ORDER_STATUS_PARTIALLYCOMPLETE && (
        <Badge><span className={getClassName('partially-complete')}>Partially Complete</span></Badge>
      )}
      {orderStatus === ORDER_STATUS_CANCELLED && (
        <Badge><span className={getClassName('cancelled')}>Cancelled</span></Badge>
      )}
    </>
  );
};

export default OrderStatusBadge;
